import React, { useEffect, useState } from 'react';
import { List } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

// Auto table of contents for long technical pages.
// items: [{ id, label }]
const TableOfContents = ({ items = [] }) => {
  const { t } = useLang();
  const [active, setActive] = useState(items[0]?.id);

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setActive(e.target.id);
        });
      },
      { rootMargin: '-30% 0px -60% 0px' }
    );
    items.forEach((it) => {
      const el = document.getElementById(it.id);
      if (el) obs.observe(el);
    });
    return () => obs.disconnect();
  }, [items]);

  const go = (e, id) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  if (!items.length) return null;

  return (
    <nav aria-label={t('common.toc')} className="rounded-xl border border-slate-200 bg-slate-50 p-5">
      <p className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.2em] text-slate-500 mb-3">
        <List className="w-3.5 h-3.5" /> {t('common.toc')}
      </p>
      <ul className="space-y-1.5">
        {items.map((it) => (
          <li key={it.id}>
            <a
              href={`#${it.id}`}
              onClick={(e) => go(e, it.id)}
              className={`block text-[13.5px] leading-snug transition-colors border-l-2 pl-3 py-0.5 ${
                active === it.id
                  ? 'border-blue-600 text-blue-700 font-semibold'
                  : 'border-transparent text-slate-600 hover:text-slate-900'
              }`}
            >
              {it.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default TableOfContents;
